export const ROOT_VIEW = 'root'
export const REFERENTIAL_VIEW = 'referential'
